import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';

export const useNewTopUpDesignSplitTest = () => {
    const { branch: splitTestBranch } = useSplitTestBranch({
        test: 'new_topup_design',
        suspense: true
    });

    return {
        branch: splitTestBranch as 'INCLUDE' | 'EXCLUDE' | undefined
    };
};
